export const TAG_COLORS = {
  ORANGE: 'orange',
  BLUE: 'blue',
  RED: 'red',
}
